// extracted by mini-css-extract-plugin
export default {"progress-container":"styles_progress-container__lny66","caption":"styles_caption__kECOK"};